module.exports = __webpack_public_path__ + "img/file-word.5966ca5b.svg";